module.exports = __webpack_public_path__ + "static/media/TINT_Font White.e45806e0.png";